/**
 * Custom Scripts - Final Drive Motors
 */

/* ---------------------------------------------------------------------
Global Js — Standalone (No external dependencies)
Target Browsers: All
------------------------------------------------------------------------ */
var FX = (function (FX) {
    document.addEventListener("DOMContentLoaded", function () {
        FX.General.init();
        FX.OpenLinksInNewTab.init();
        FX.MobileMenu.init();
        FX.MobileSearch.init();
    });

    window.addEventListener("load", function () {
        FX.BackToTop.init();
    });

    FX.BackToTop = {
        elBtn: null,

        init() {
            this.elBtn = document.querySelector(".js-back-to-top");

            if (null !== this.elBtn) {
                this.bind();
            }
        },

        bind() {
            this.elBtn.addEventListener("click", this.scrollToTop.bind(this));
        },

        scrollToTop() {
            window.scrollTo({ top: 0, behavior: "smooth" });
        },
    };

    FX.General = {
        init: function () {
            this.bind();
        },

        bind: function () {
            document.querySelectorAll('a[href*=".pdf"]').forEach(function (link) {
                link.setAttribute("target", "_blank");
            });

            var searchToggle = document.querySelector(".js-search-toggle");
            if (searchToggle) {
                searchToggle.addEventListener("click", function () {
                    document
                        .querySelectorAll(
                            ".desktop-menu__phone, .js-search-toggle, .desktop-menu__search"
                        )
                        .forEach(function (el) {
                            el.classList.toggle("js-search-active");
                        });

                    var searchInput = document.querySelector(
                        '.desktop-menu__search input[name="s"]'
                    );
                    if (searchInput) searchInput.focus();
                });
            }
        },
    };

    FX.MobileMenu = {
        init: function () {
            document
                .querySelectorAll(".nav-primary li.menu-item-has-children > a")
                .forEach(function (link) {
                    var span = document.createElement("span");
                    span.className = "sub-menu-toggle icon-arrow-down hidden-md-up";
                    link.parentNode.insertBefore(span, link.nextSibling);
                });

            document
                .querySelectorAll(".sub-menu-toggle")
                .forEach(function (toggle) {
                    toggle.addEventListener("click", function () {
                        var parent = this.closest("li");
                        var subMenu = parent.querySelector(":scope > .sub-menu");
                        if (subMenu) subMenu.classList.toggle("js-toggled");
                        this.classList.toggle("js-toggled");
                    });
                });
        },
    };

    FX.OpenLinksInNewTab = {
        init() {
            this.HandleExternalLinks();
            this.HandlePDFLinks();
        },

        HandleExternalLinks() {
            var currentHost = window.location.hostname.replace(/^www\./, "");

            document.querySelectorAll('a[href*="//"]').forEach(function (link) {
                if (link.classList.contains("ignore-external")) return;

                try {
                    var linkHost = new URL(link.href).hostname.replace(/^www\./, "");
                    if (linkHost !== currentHost) {
                        link.classList.add("external");
                        link.setAttribute("target", "_blank");
                        link.setAttribute("rel", "noopener");
                    }
                } catch (e) {
                    // skip malformed URLs
                }
            });
        },

        HandlePDFLinks() {
            document.querySelectorAll('a[href$=".pdf"]').forEach(function (link) {
                link.setAttribute("target", "_blank");
            });
        },
    };

    FX.Affix = {
        body: null,
        header: null,
        headerHeight: 0,
        scrollTimeout: null,
        resizeTimeout: null,

        init: function () {
            this.body = document.body;
            this.header = document.getElementById("page-header");
            if (!this.header) return;

            this.headerHeight = this.header.offsetHeight;
            this.bind();
        },

        bind: function () {
            window.addEventListener("scroll", this.handleScroll.bind(this));
            window.addEventListener("resize", this.handleResize.bind(this));
        },

        handleScroll: function () {
            var self = this;
            if (self.scrollTimeout !== null) clearTimeout(self.scrollTimeout);

            self.scrollTimeout = setTimeout(function () {
                self.maybeAffixHeader();
            }, 500);
        },

        handleResize: function () {
            var self = this;
            if (self.resizeTimeout !== null) clearTimeout(self.resizeTimeout);

            self.resizeTimeout = setTimeout(function () {
                self.headerHeight = self.header.offsetHeight;
            }, 500);
        },

        maybeAffixHeader: function () {
            if (200 < window.scrollY) {
                this.body.style.paddingTop = this.headerHeight + "px";
                this.header.classList.add("js-scrolled");
            } else {
                this.body.style.paddingTop = "0";
                this.header.classList.remove("js-scrolled");
            }
        },
    };

    FX.SmoothAnchors = {
        init: function () {
            this.hash = window.location.hash;
            if (this.hash !== "") {
                this.scrollToSmooth(this.hash);
            }
            this.bind();
        },

        bind: function () {
            var self = this;
            document.querySelectorAll('a[href^="#"]').forEach(function (link) {
                link.addEventListener("click", function (e) {
                    e.preventDefault();
                    self.scrollToSmooth(this.getAttribute("href"));
                });
            });
        },

        scrollToSmooth: function (target) {
            var el = document.querySelector(target);
            if (!el) return;

            var headerHeight = 0;
            var targetOffset = el.getBoundingClientRect().top + window.scrollY - headerHeight;

            window.scrollTo({ top: targetOffset, behavior: "smooth" });
        },
    };

    FX.MobileSearch = {
        init: function () {
            this.bind();
        },

        bind: function () {
            var self = this;
            var mobileSearch = document.querySelector(".mobile-search");
            if (mobileSearch) mobileSearch.classList.add("hide");

            document
                .querySelectorAll(".mobile-search-toggle")
                .forEach(function (btn) {
                    btn.addEventListener("click", function () {
                        self.toggleSearch(this);
                    });
                });
        },

        toggleSearch: function (toggleButton) {
            toggleButton.classList.toggle("mobile-search-toggle-active");
            var mobileSearch = document.querySelector(".mobile-search");
            if (!mobileSearch) return;

            if (toggleButton.classList.contains("mobile-search-toggle-active")) {
                mobileSearch.classList.remove("hide");
                mobileSearch.classList.add("mobile-search-active");

                var searchInput = mobileSearch.querySelector("input[name='s']");
                if (searchInput) searchInput.focus();
            } else {
                mobileSearch.classList.add("hide");
                mobileSearch.classList.remove("mobile-search-active");
            }
        },
    };

    return FX;
})(FX || {});
